import axios from 'axios'

// 定义配置类型
interface WebConfig {
  [key: string]: any
}

export async function getConfig(): Promise<void> {
  try {
    const { data: config } = await axios.get('/store/config/web-config-distribution.json')
    sessionStorage.setItem('config', JSON.stringify(config))
  } catch (error) {
    console.error('Failed to get web config:', error)
  }
}

export function getStoredConfig(): WebConfig | null {
  const configStr = sessionStorage.getItem('config')
  if (!configStr) {
    return null
  }
  try {
    return JSON.parse(configStr) as WebConfig
  } catch {
    return null
  }
}
